import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgDownload = (props) => /* @__PURE__ */ _jsxs("svg", {
	viewBox: "0 0 24 24",
	xmlns: "http://www.w3.org/2000/svg",
	fill: "currentColor",
	...props,
	children: [/* @__PURE__ */ _jsx("path", { d: "m21 19h-18a1 1 0 0 0 0 2h18a1 1 0 0 0 0-2z" }), /* @__PURE__ */ _jsx("path", { d: "m12 2a1 1 0 0 0 -1 1v10.59l-3.29-3.3a1 1 0 0 0 -1.42 1.42l5 5a1 1 0 0 0 1.42 0l5-5a1 1 0 0 0 -1.42-1.42l-3.29 3.3v-10.59a1 1 0 0 0 -1-1z" })]
});
export default SvgDownload;
